import React from 'react';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledChip = styled(Chip)(({ theme, variant }) => ({
  height: '32px',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: 500,
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
  
  
  ...(variant === 'outlined' && {
    backgroundColor: 'transparent',
    border: '1px solid #E0E0E0',
    color: '#424242',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      borderColor: '#BDBDBD',
    },
    '&:focus': {
      backgroundColor: '#F5F5F5',
    },
  }),
  
 
  ...(variant === 'filled' && {
    backgroundColor: '#F3E5F5',
    border: 'none',
    color: '#7B1FA2',
    '&:hover': {
      backgroundColor: '#E1BEE7',
    },
    '&:focus': {
      backgroundColor: '#E1BEE7',
    },
  }),
  
  // Primary variant (with icon)
  ...(variant === 'primary' && {
    backgroundColor: '#E8F5E8',
    border: 'none',
    color: '#2E7D32',
    '& .MuiChip-icon': {
      color: '#2E7D32',
      fontSize: '16px',
    },
    '&:hover': {
      backgroundColor: '#C8E6C9',
    },
    '&:focus': {
      backgroundColor: '#C8E6C9',
    },
  }),
  
  // Delete icon styling
  '& .MuiChip-deleteIcon': {
    fontSize: '16px',
    color: 'inherit',
    '&:hover': {
      color: 'inherit',
    },
  },
  
 
  '& .MuiChip-label': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}));

const SuggestionClip = ({ 
  label = "Label",
  variant = "outlined",  
  icon,
  onDelete,
  onClick,
  style,
  ...props 
}) => {
  return (
    <StyledChip
      label={label}
      variant={variant}
      icon={icon}
      onDelete={onDelete}
      onClick={onClick}
      style={style}
      {...props}
    />
  );
};

export default SuggestionClip;
